import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, Form } from 'redux-form/immutable';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';

import ReduxDialog from '../../Common/ReduxDialog/index';
import { renderTextField } from '../../../utils/reduxforms';
import { hideDialog } from '../../../redux/actions/dialogs';

import styles from './styles';
import { email, phoneNumber, required } from '../../../utils/formvalidation';
import { CONTACT_DIALOG } from '../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../redux/selectors';

class ContactDialog extends React.Component {
  render() {
    const { handleSubmit, initialValues, hideDialog, submit } = this.props;
    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="default"
        onClick={() => hideDialog(CONTACT_DIALOG)}
      >Cancel</Button>,
      <Button
        key="submit"
        variant="contained"
        color="primary"
        autoFocus
        type="submit"
        onClick={() => submit()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={CONTACT_DIALOG}
        title={initialValues && initialValues.get('id') ? initialValues.get('name') || '' : 'Add New Contact'}
        actions={actions}
        modal={false}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit} style={styles.body}>
          <Grid container spacing={8}>
            <Grid item xs={6}>
              <Field
                name="firstName"
                component={renderTextField}
                label="First Name"
                fullWidth
                validate={required}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                name="lastName"
                component={renderTextField}
                label="Last Name"
                fullWidth
                validate={required}
              />
            </Grid>

            <Grid item xs={6}>
              <Field
                name="telephone"
                component={renderTextField}
                label="Telephone"
                fullWidth
                validate={phoneNumber}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                name="mobile"
                component={renderTextField}
                label="Mobile"
                fullWidth
                validate={phoneNumber}
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                name="email"
                component={renderTextField}
                label="Email"
                fullWidth
                validate={email}
              />
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

ContactDialog.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

const form = reduxForm({
  form: CONTACT_DIALOG,  // a unique identifier for this form
  // enableReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    // props.onSuccess(_.assign({ id: id() }, values.toJS(), { name: `${values.get('firstName')} ${values.get('lastName')}` }));
    props.onSuccess(values.toJS());
    props.hideDialog(CONTACT_DIALOG);
  },
})(ContactDialog);

function mapStateToProps(state) {
  return {
    initialValues: getDialogContextValue(state)(CONTACT_DIALOG, 'contact'),
    onSuccess: getDialogContextValue(state)(CONTACT_DIALOG, 'onSuccess'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactDialog/index.js